import React, { useEffect } from 'react';
import './customerLogs.scss';
import { IUser } from '../../models';
import PaneHeadline from '../shared/paneHeadline';
import { faList } from '@fortawesome/free-solid-svg-icons';
import CustomerLogsGrid from './CustomerLogsGrid';
import EventBus from '../../common/EventBus';
import { locale } from '../../common/localization/localizationService';
import routes from '../../common/routes';
import { Spinner2 } from '../shared/spinner2';
import { ICustomerLog } from '../../models/CustomerLogs.model';

export interface ICustomerLogsProps {
  impersonatedUser: any;
  authentication: IUser;
  location: any;
  selectedCustomer: any;
  customerLogs: Array<ICustomerLog>;
  isLoading: boolean;
  dataButtons: Array<any>;
  getCustomerLogs: (agreementId: number, paSystem: string) => void;
  setSelectedLogline: (logline: ICustomerLog) => void;
}

export default function CustomerLogs(props: ICustomerLogsProps): JSX.Element {
  const backUrl = routes.customerSearch;
  useEffect(() => {
    const selectedCustomer = props.selectedCustomer;
    props.getCustomerLogs(
      selectedCustomer.agreementId,
      selectedCustomer.paSystem
    );
    EventBus.emit('fullScreenChange', true);

    return () => {
      EventBus.emit('fullScreenChange', false);
    };
  }, []);

  return (
    <>
      <div className="customer-logs">
        <div className="customer-logs-header-row">
          <PaneHeadline
            titleText={`${locale.customerLogs._customerLogs} - ${props.selectedCustomer.estate}`}
            titleIcon={faList}
            backTitle={locale.general._customerRegister}
            backUrl={backUrl}
          />
        </div>
        <Spinner2 show={props.isLoading} />
        <div className="customer-logs-content">
          <CustomerLogsGrid
            data={props.customerLogs}
            setSelectedLogline={props.setSelectedLogline}
            dataButtons={props.dataButtons}
          />
        </div>
      </div>
    </>
  );
}
